//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
let d=[[],[[["nPartitionSchemes","partitionSchemes"],"GetAllPartitionSchemes",{},0,0],[["schemeName","schemeType"],"FindPartitionScheme",{R_:{partitionScheme:"Assemblies.PartitionScheme"}},2,0],[["partitionName","partitionType"],"FindPartition",{R_:{partitions:"Assemblies.Partition"}},2,0]],[]];
SPLM.Assemblies.PartitionSchemeManager = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.PartitionSchemeManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;